import { render } from "./update-range-level.view.vue?vue&type=template&id=28ff3c5a&ts=true"
import script from "./update-range-level.view.vue?vue&type=script&lang=ts"
export * from "./update-range-level.view.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__